// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__Jhksq","h1":"NotFound_h1__TSEoC","h2":"NotFound_h2__g-hVJ","link":"NotFound_link__U4so3"};